import { produce } from 'immer';

import { AddInternalMarketerProductAccess } from '../../../actions/marketer/internal/addInternalMarketerProductAccess';
import { MarketersPageStates, MarketerState } from '../../../typings/marketers';

export function addInternalMarketerProductAccess(
    state: MarketerState,
    action: AddInternalMarketerProductAccess
): MarketerState {
    return produce(state, draft => {
        draft.pageStatus = MarketersPageStates.FETCH_FORM;
    });
}
